import styled from "styled-components";

export default styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  min-height: 50px;
`;
